export const CHAMPIONS_SET_SELECTED_ROW_IDS = 'championsSetSelectedRowIds'

export type ChampionsTableDispatch = (action: { type: string; selectedRowIds?: Record<string, boolean> }) => void

export const ROW_SELECT_ACTIONS = ['toggleRowSelected', 'toggleAllPageRowsSelected', 'toggleAllRowsSelected'] as const
